import { Article } from '@mui/icons-material';
import DeleteIcon from '@mui/icons-material/Delete';
import ModeEditOutlineIcon from '@mui/icons-material/ModeEditOutline';
import { GridActionsCellItem } from '@mui/x-data-grid';
import placeholderImage from 'assets/images/placeholder.svg';
import ColImage from 'components/shared/Table/ColImage';

import TableActionButtons from '../../components/shared/TableActionButtons/TableActionButtons';

const useProductSearchTableColumns = (
  deleteItem,
  editItem,
  reportItem,
  apiRef,
  { reportDisabled = false } = {},
) => {
  const columnsData = [
    {
      field: 'imageUrl',
      headerName: 'تصویر',
      flex: 1,
      minWidth: 120,
      minHeight: 120,
      height: 120,
      resizable: true,
      editable: false,
      renderCell: params => {
        apiRef.current = params.api;
        return (
          <ColImage
            src={params.row.imageUrl || placeholderImage}
            alt={params.row.title}
          />
        );
      },
    },
    {
      field: 'title',
      headerName: 'عنوان',
      flex: 1,
      minWidth: 120,
      resizable: true,
      editable: false,
      renderCell: params => {
        apiRef.current = params.api;
        return params.row.title;
      },
    },
    {
      field: 'packDisplay',
      headerName: 'بسته بندی',
      flex: 0.8,
      minWidth: 130,
      resizable: true,
      editable: false,
    },
    {
      field: 'code',
      headerName: 'کد',
      flex: 1,
      minWidth: 120,
      resizable: true,
      editable: false,
    },
    {
      field: 'quantity',
      headerName: 'تعداد',
      flex: 1,
      minWidth: 60,
      resizable: true,
      editable: false,
    },
    {
      field: 'actions',
      headerName: 'عملیات',
      type: 'actions',
      flex: 0.5,
      align: 'right',
      minWidth: reportDisabled ? 180 : 260,
      getActions: params => [
        <TableActionButtons
          key="actions"
          buttons={[
            {
              label: 'ویرایش',
              Icon: ModeEditOutlineIcon,
              onClick: editItem(params.row),
              color: 'info',
            },
            ...(!reportDisabled
              ? [
                  {
                    label: 'گزارشات',
                    Icon: Article,
                    onClick: reportItem(params.row),
                    color: 'info',
                    variant: 'outlined',
                  },
                ]
              : []),
          ]}
        />,
        <GridActionsCellItem
          key="delete"
          icon={<DeleteIcon />}
          label="حذف"
          onClick={deleteItem(params.row)}
          showInMenu
        />,
      ],
    },
  ];

  return [columnsData];
};

export default useProductSearchTableColumns;
